import React from "react";

 const AboutSection =()=> {
  return (
    <section className="about-section section">

      <div className="container about-wrapper">

        {/* LEFT CONTENT */}

        <div className="about-content">

          <h2 className="about-title">Who We Are ?</h2>

          <p className="about-text">
            <span className="highlight">Axepert Exhibits (P) Ltd.</span> is a New
            Delhi–based IT system integration and software development company
            providing IT consultancy, custom software, and web application
            solutions. With a focus on quality user experience and timely
            delivery, the company helps enterprises implement and manage complex
            IT systems efficiently and gain a competitive edge.
          </p>

          <p className="about-text">
            Backed by technical expertise and innovative strategies, Axepert
            delivers <span className="highlight">tailored solutions</span> that
            adapt to evolving business needs. Their commitment to reliability,
            performance, and long-term client partnerships ensures sustainable
            growth and operational excellence for organizations.
          </p>

        </div>


        {/* RIGHT VIDEO */}

        <div className="about-video">

          <video
            autoPlay
            muted
            loop
            playsInline
            className="video-box"
          >
            <source src="/assets/whoweare.mp4" type="video/mp4" />
          </video>

        </div>

      </div>

    </section>
  );
}
export default AboutSection;